import { render, staticRenderFns } from "./y-dialog.vue?vue&type=template&id=2503ce70&"
import script from "./y-dialog.vue?vue&type=script&lang=js&"
export * from "./y-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports